module.exports = ".container-fluid {\n  padding: 0;\n  width: 100%; }\n"